import styled from 'styled-components';

// 4px gap matches Edits Field-card stacking. box-sizing keeps padding inside
// width — outer Container owns scroll, no internal overflow needed.
export const Base = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 0;
	box-sizing: border-box;
	gap: 4px;
	padding: 12px;
`;

export const ScrollingArea = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

// Each comment is a tinted card matching the Edits section's Field aesthetic.
export const Comment = styled.div`
	padding: 8px 10px;
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 6px;
`;

export const CommentHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
`;

export const UserInfo = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
`;

export const UserIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const UserId = styled.div`
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[700]};
`;

export const Timestamp = styled.div`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[600]};
`;

export const CommentContent = styled.div`
	font-size: 13px;
	line-height: 18px;
	color: ${({ theme }) => theme.gray[1000]};

	// Markdown styles
	p {
		margin: 0 0 8px 0;
		&:last-child {
			margin-bottom: 0;
		}
	}

	code {
		background-color: ${({ theme }) => theme.gray[200]};
		padding: 2px 4px;
		border-radius: 4px;
		font-size: 12px;
	}

	pre {
		background-color: ${({ theme }) => theme.gray[100]};
		padding: 8px;
		border-radius: 4px;
		overflow-x: auto;
		margin: 8px 0;
	}
`;

// Top-level comment + its replies. min-width: 0 lets it shrink in flex column.
export const Thread = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
`;

export const ReplyList = styled.div`
	margin-left: 16px;
	padding-left: 8px;
	border-left: 2px solid ${({ theme }) => theme.gray[200]};
	display: flex;
	flex-direction: column;
	gap: 4px;
`;
